<template>
  <div class="content">
    <div class="container-fluid">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <span class="nav-link" v-bind:class="{active: showUserTab}" @click="showUsers">Users</span>
        </li>
        <li class="nav-item">
          <span class="nav-link" v-bind:class="{active: showLicenseTab}" @click="showLicenses">Licenses</span>
        </li>
        <li class="nav-item">
          <span class="nav-link" v-bind:class="{active: showInvoiceTab}" @click="showInvoices">Invoices</span>
        </li>
      </ul>

      <PagerDutyUsers v-if="showUserTab"/>
      <PagerDutyLicenses v-if="showLicenseTab"/>
      <div class="row" v-if="showInvoiceTab">
        <div class="col-md-10">
          <chart-card :key='pagerduty_costs_data' :chart-data="pagerduty_costs_data.data"
                      :chart-options="pagerduty_costs_data.options"
                      :responsive-options="pagerduty_costs_data.responsiveOptions"
                      chart-type="Bar"
                      >
            <template slot="header">
              <h4 class="card-title">Pager Duty Invoices</h4>
              <p class="card-category">Values in $</p>
            </template>
          </chart-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import PagerDutyUsers from './pagerdutyusers.vue'
  import PagerDutyLicenses from './pagerdutylicenses.vue'
  import axios from 'axios'

  import { colors, formatMoney, formatSimple } from 'src/globalVariables'
  import { setInterval } from 'timers';



  Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard,
      PagerDutyUsers,
      PagerDutyLicenses,
    },
    async created() {
      this.accessToken = await this.$auth.getAccessToken()
      this.loadData()
      var vm = this
      setInterval(function(){
        vm.loadData()
      },vm.refresh_minutes*60*1000)

    },
    methods: {
      loadData: function(){
        let today = new Date();
        this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2)
        console.log('refreshing...',)
        axios
          .get('invoices/current-data?access_token=' + this.accessToken + '&vendor_name=PagerDuty&st_date=201801&fn_date=201912')
          .then(response => (this.pagerduty_invoices = response.data))
        return true
      },
      refresh_pagerduty: function() {
        let labels = []
        let series1 = []
        if (this.pagerduty_invoices){
          this.pagerduty_invoices.forEach(function(v, i){
            labels.push(v['period'])
            series1.push(parseFloat(v['cost']))

          })
          this.pagerduty_costs_data = {
            'data': {
              'labels': labels,
              'series': [series1]
            },
            'options': {
              'stackBars': true,
              'seriesBarWidth': 50,
              'seriesBarDistance': 50,
              'axisX': {
                'showGrid': true
              },
              'height': '245px',
              'chartPadding': {
                'right': 50,
                'left': 50,
              },
              'tooltip':{
                'tooltipFnc': function(meta, value){
                  return(value)
                },

                tooltipOffset: {
                  x: 15,
                  y: 90
                },
                'appendToBody':false,
                'transformTooltipTextFnc': function(value) {
                  return ''+ formatMoney.format(value)
                  }
              },
              // 'ctPointLabels':{
              //   'textAnchor': 'middle',
              //   'labelOffset': {
              //     'x': 0,
              //     'y': -10
              //   },
              //   // labelInterpolationFnc: function(value) {return '$' + value.toFixed(2)}
              // }
            },
            'responsiveOptions': [
              ['screen and (max-width: 640px)', {
                'seriesBarDistance': 20,
                'axisX': {
                  labelInterpolationFnc (value) {
                    return value[0]
                  }
                }
              }]
            ]
          }

        }

      },
      showUsers(){
        this.showUserTab = true;
        this.showLicenseTab = false;
        this.showInvoiceTab = false;
      },
      showLicenses(){
        this.showUserTab = false;
        this.showLicenseTab = true;
        this.showInvoiceTab = false;
      },
      showInvoices(){
        this.showUserTab = false;
        this.showLicenseTab = false;
        this.showInvoiceTab = true;
      },
    },
    watch: {
      pagerduty_invoices:function(){
        this.refresh_pagerduty()
      },
    },
    computed: {

    },
    data () {
      return {
        refresh_minutes: 30,
        last_update: '',
        colors: colors,
        pagerduty_invoices:{},
        pagerduty_costs_data:{},
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        accessToken: '',
        showUserTab: true,
        showLicenseTab: false,
        showInvoiceTab: false,
      }
    }
  }
</script>
<style>

</style>
